export type Enum<TEnum extends object> = TEnum[keyof TEnum];

export const TENANT_SUBSCRIPTIONL_PLAN = {
    FREE: 'free',
    COMBO_STARTER: 'combo-starter',
    STARTER: 'starter',
    COMBO_ESSENTIAL: 'combo-essential',
    PRO: 'pro',
    COMBO_PRO: 'combo-pro',
    ENTERPRISE: 'enterprise',
    COMBO_ENTERPRISE: 'combo-enterprise',
    COMBO_FREE: 'combo-free',
    GROWTH: 'growth',
} as const;

export const BENEFIT = {
    COMPOSED_WORKS: 'composed_works',
    WORKSITE_CLOSURE_REPORTS: 'worksite_closure_reports',
    PLANNING: 'planning',
    CRM: 'crm',
    PROGRESS_BILLINGS: 'progress_billings',
    PROFITABILITY: 'profitability',
    DOCUMENTS: 'documents',
    TIME_SHEETS: 'time_sheets',
} as const;

export type Benefit = Enum<typeof BENEFIT>;

export const BELGIUM_TENANT_SUBSCRIPTION_PLAN_CONFIG = {
    [TENANT_SUBSCRIPTIONL_PLAN.FREE]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.FREE,
        name: TENANT_SUBSCRIPTIONL_PLAN.FREE,
        benefits: [],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.STARTER, TENANT_SUBSCRIPTIONL_PLAN.ENTERPRISE],
        isCombo: false,
        isActive: true,
        isLegacy: false,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.COMBO_FREE]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.COMBO_FREE,
        name: TENANT_SUBSCRIPTIONL_PLAN.COMBO_FREE,
        benefits: [],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.COMBO_ESSENTIAL, TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE],
        isCombo: true,
        isActive: true,
        isLegacy: false,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.STARTER]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.STARTER,
        name: TENANT_SUBSCRIPTIONL_PLAN.STARTER,
        benefits: [],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.ENTERPRISE],
        isCombo: false,
        isActive: true,
        isLegacy: false,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.COMBO_STARTER]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.COMBO_STARTER,
        name: TENANT_SUBSCRIPTIONL_PLAN.COMBO_STARTER,
        benefits: [],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.COMBO_ESSENTIAL, TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE],
        isCombo: true,
        isActive: false,
        isLegacy: true,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.COMBO_ESSENTIAL]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.COMBO_ESSENTIAL,
        name: TENANT_SUBSCRIPTIONL_PLAN.COMBO_ESSENTIAL,
        benefits: [],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE],
        isCombo: true,
        isActive: true,
        isLegacy: false,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.PRO]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.PRO,
        name: TENANT_SUBSCRIPTIONL_PLAN.PRO,
        benefits: [BENEFIT.COMPOSED_WORKS, BENEFIT.WORKSITE_CLOSURE_REPORTS, BENEFIT.PLANNING, BENEFIT.CRM],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.ENTERPRISE],
        isCombo: false,
        isActive: false,
        isLegacy: true,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.COMBO_PRO]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.COMBO_PRO,
        name: TENANT_SUBSCRIPTIONL_PLAN.COMBO_PRO,
        benefits: [BENEFIT.COMPOSED_WORKS, BENEFIT.WORKSITE_CLOSURE_REPORTS, BENEFIT.PLANNING, BENEFIT.CRM, BENEFIT.PROGRESS_BILLINGS, BENEFIT.PROFITABILITY, BENEFIT.DOCUMENTS, BENEFIT.TIME_SHEETS],
        upsellPlans: [TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE],
        isCombo: true,
        isActive: false,
        isLegacy: true,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.ENTERPRISE]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.ENTERPRISE,
        name: TENANT_SUBSCRIPTIONL_PLAN.ENTERPRISE,
        benefits: [BENEFIT.COMPOSED_WORKS, BENEFIT.WORKSITE_CLOSURE_REPORTS, BENEFIT.PLANNING, BENEFIT.CRM, BENEFIT.PROGRESS_BILLINGS, BENEFIT.PROFITABILITY, BENEFIT.DOCUMENTS, BENEFIT.TIME_SHEETS],
        upsellPlans: [],
        isCombo: false,
        isActive: true,
        isLegacy: false,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE,
        name: TENANT_SUBSCRIPTIONL_PLAN.COMBO_ENTERPRISE,
        benefits: [BENEFIT.COMPOSED_WORKS, BENEFIT.WORKSITE_CLOSURE_REPORTS, BENEFIT.PLANNING, BENEFIT.CRM, BENEFIT.PROGRESS_BILLINGS, BENEFIT.PROFITABILITY, BENEFIT.DOCUMENTS, BENEFIT.TIME_SHEETS],
        upsellPlans: [],
        isCombo: true,
        isActive: true,
        isLegacy: false,
    },
    [TENANT_SUBSCRIPTIONL_PLAN.GROWTH]: {
        key: TENANT_SUBSCRIPTIONL_PLAN.GROWTH,
        name: TENANT_SUBSCRIPTIONL_PLAN.GROWTH,
        benefits: [BENEFIT.COMPOSED_WORKS, BENEFIT.WORKSITE_CLOSURE_REPORTS, BENEFIT.PLANNING, BENEFIT.CRM, BENEFIT.PROGRESS_BILLINGS, BENEFIT.PROFITABILITY, BENEFIT.DOCUMENTS, BENEFIT.TIME_SHEETS],
        upsellPlans: [],
        isCombo: false,
        isActive: false,
        isLegacy: true,
    },
} as const;

export const COUNTRY = {
    BELGIUM: 'be',
    FRANCE: 'fr',
} as const;

export type Country = Enum<typeof COUNTRY>;

export const TENANT_SUBSCRIPTION_PLAN_CONFIG = {
    [COUNTRY.BELGIUM]: BELGIUM_TENANT_SUBSCRIPTION_PLAN_CONFIG,
    [COUNTRY.FRANCE]: BELGIUM_TENANT_SUBSCRIPTION_PLAN_CONFIG,
} as const;

export type SubscriptionPlan = Enum<typeof TENANT_SUBSCRIPTIONL_PLAN>;
export type SubscriptionPlanConfig = Enum<(typeof TENANT_SUBSCRIPTION_PLAN_CONFIG)[keyof typeof TENANT_SUBSCRIPTION_PLAN_CONFIG]>;
